import { TRIP_COLORS } from "@pack-it-up/shared";
import { vars } from "./theme/contract.css.js";
export const tripHueColor = {
    orange: vars.color.accent,
    blue: vars.color.info,
    green: vars.color.success,
    purple: vars.color.tripPurple,
    pink: vars.color.tripPink,
    teal: "#14b8a6",
    indigo: "#6366f1",
    rose: "#f43f5e",
    lime: "#84cc16",
    cyan: "#06b6d4",
};
// Faint tint fill per hue, for the countdown pill. The first five reuse the theme's
// *Subtle tokens; the extras are 14%-alpha literals of their hue.
export const tripHueTint = {
    orange: vars.color.accentSubtle,
    blue: vars.color.infoSubtle,
    green: vars.color.successSubtle,
    purple: vars.color.tripPurpleSubtle,
    pink: vars.color.tripPinkSubtle,
    teal: "rgba(20, 184, 166, 0.14)",
    indigo: "rgba(99, 102, 241, 0.14)",
    rose: "rgba(244, 63, 94, 0.14)",
    lime: "rgba(132, 204, 22, 0.14)",
    cyan: "rgba(6, 182, 212, 0.14)",
};
export const TRIP_HUES = [...TRIP_COLORS];
// The domain stores no trip hue — derive a stable one from the trip id so a trip keeps the
// same colour everywhere it appears (sidebar dot, card stripe, countdown pill). A wider
// palette makes it more likely each trip gets a distinct colour.
export const tripColorFor = (id) => {
    let h = 0;
    for (let i = 0; i < id.length; i++)
        h = (h * 31 + id.charCodeAt(i)) >>> 0;
    return TRIP_HUES[h % TRIP_HUES.length];
};
//# sourceMappingURL=tripHues.js.map